module.exports = {
	"title": "Shedding after exposure to live poliovirus",
	"authors": "Supplemental material for ''How polio vaccination affects poliovirus transmssion.'' Preprint available at http://biorxiv.org/ and data, analysis code, and transmission models at https://GitHubRepo.",
	"caption": "Interactive tool to explore data on shedding duration and concentration of poliovirus in stool after OPV challenge or natural exposure to wild poliovirus. Click on the boxes at the top or bottom of the page and scroll to explore. Gradient colormaps get darker with increasing value of the coloring parameter. Discrete colormaps group by category.",
	"visualizations": [
		{
			"name": "Impact of RI on shedding duration.",
			"routeName": "durationAfterRI",
			"caption": "Reverse-cumulative distributions for the duration of fecal poliovirus shedding after infection with live poliovirus. Each curve represents the average of all trial arms with the same detailed routime immunization (number and type of doses).",
			"csv": "meanSheddingDurationCDF.CSV",
			"defaultCategory": "0@S1"
		},
		{
			"name": "Shedding duration for each trial arm.",
			"routeName": "durationByArm",
			"caption": "Reverse-cumulative distributions for the duration of fecal poliovirus shedding after infection with live poliovirus. Each curve represents a single trial arm reported in the literature.  The associated metadata describe the demographics of the subjects and the source.",
			"csv": "allSheddingDurationCDF.CSV",
			"defaultCategory": "1@WPV"
		},
		{
			"name": "Impact of RI on fecal concentration.",
			"routeName": "concentrationAfterRI",
			"caption": "Geometric mean titers for the concentration of poliovirus in stool after infection with live poliovirus. Each curve represents the average of all trial arms with the same detailed routime immunization (number and type of doses) after adjusting the underlying trial arms to represent subjects 12 months of age.",
			"csv": "meanSheddingViralLoadGMT.csv",
			"defaultCategory": "1@S2"
		},
		{
			"name": "Fecal concentration for each trial arm.",
			"routeName": "concentrationByArm",
			"caption": "Geometric mean titers for the concentration of poliovirus in stool after infection with live poliovirus. Each curve represents a single trial arm reported in the literature.  The associated metadata describe the demographics of the subjects and the source.",
			"csv": "allSheddingViralLoadGMT.CSV",
			"defaultCategory": ""
		}
	]
};


/*****************
 ** WEBPACK FOOTER
 ** ./data/visualizationLibrary.json
 ** module id = 74
 ** module chunks = 0
 **/